"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageId = void 0;
const v4_1 = __importDefault(require("uuid/v4"));
class MessageId {
    constructor(messageId) {
        const segments = messageId.split('_');
        [this.prefix] = segments;
        this.id = parseInt(segments[1], 10);
    }
    static getRandomPrefix(prefix) {
        return `${prefix}-${v4_1.default().toString('utf8').replace(/-/g, '')}`;
    }
    toString() {
        return `${this.prefix}_${this.id}`;
    }
    toJSON() {
        return this.toString();
    }
}
exports.MessageId = MessageId;
//# sourceMappingURL=MessageId.js.map